import { Strategy } from 'utility-ts-strategy';
export const ActionMessageStringStrategy = new Strategy({
  ACCEPT: 'accepted',
  REJECT: 'declined'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/strategies/action_message_string_strategy.ts